export const ellipsis = (str: string, length: number = 100, ending: string = '<...>') =>
    str.length > length ? `${str.substring(0, length - ending.length)}${ending}` : str;
